import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { NotFoundComponent } from "./modules/shared/components/not-found/not-found.component";
import { ErrorComponent } from "./modules/shared/components/error/error.component";
import { LoginComponent } from "./modules/vnext/auth/login/login.component";
import { authGuard } from "../app/modules/vnext/auth/auth-guard.guard";
import { canonicalRouteCaseGuard } from "./@core/routing/canonical-route-case";

/**
 * Top-level routes: public `login`/`error` pages, the lazy-loaded vnext feature
 * module at the root path, and the Auth0-guarded wallet management screens.
 */
export const routes: Routes = [
  {
    path: "error",
    component: ErrorComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  // The logo pointed here for years, a leftover of the ngx-admin template, and it 404ed. Kept as a
  // redirect so bookmarks and muscle memory land on the dashboard (work item 749).
  {
    path: "pages/dashboard",
    redirectTo: "/dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    // The routes array rather than VnextRoutingModule, so canonicalRouteCaseGuard can read the
    // lazy children without instantiating a module (work item 925). Routing is the same.
    loadChildren: () =>
      import("./modules/vnext/vnext-routing.module").then((m) => m.routes),
  },
  {
    path: 'wallet-user-admin',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/user-admin/components/user-admin-container/user-admin-container.component').then(m => m.UserAdminContainerComponent),
  },
  {
    path: 'management-system-users',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/management-system/components/mgt-users/mgt-users.component').then(m => m.MgtUsersComponent),
  },
  {
    path: 'management-system-wallet',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/management-system/components/mgt-wallet/mgt-wallet.component').then(m => m.MgtWalletComponent),
  },
  {
    path: 'management-system-transaction',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/management-system/components/mgt-transaction/mgt-transaction.component').then(m => m.MgtTransactionComponent),
  },
  {
    path: 'management-system-device',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/management-system/components/mgt-device/mgt-device.component').then(m => m.MgtDeviceComponent),
  },
  {
    // Work item 936: card sales the wallet never credited, and replaying them.
    path: 'wallet-card-payments',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/card-payments/card-payments.component').then(m => m.CardPaymentsComponent),
  },
  {
    path: 'wallet-device-lookup',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/wallet/management-system/components/device-lookup/device-lookup.component').then(m => m.DeviceLookupComponent),
  },
  // A link that differs only in capitals (/Contracts/{id}) is redirected to the declared path
  // before this gives up and shows not found (work item 925).
  { path: "**", canMatch: [canonicalRouteCaseGuard], component: NotFoundComponent },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
/** Root routing module wiring {@link routes} into the Angular router. */
export class AppRoutingModule {}
